import { BrowserRouter } from "react-router-dom";
import "./App.css";
import RoutesLeiva from "./RoutesLeiva";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RoutesLeiva />
      </BrowserRouter>
    </div>
  );
}

export default App;
